import { GeoFence } from '../../../../../domain/geoFence/GeoFence';
import { PlanDetailsActionType } from '../../context/actions';
import { usePlanDetailsContext } from '../../context/context';

type UseSetPlanEditingGeoFenceResponse = {
  run: (editingGeoFence?: GeoFence) => void;
  data: GeoFence | undefined;
};

// Hooks act as 'Adapter' layer.
export const useSetPlanEditingGeoFence = (): UseSetPlanEditingGeoFenceResponse => {
  const { planDetailsState, planDetailsDispatch } = usePlanDetailsContext();

  const run = (editingGeoFence?: GeoFence) => {
    if (editingGeoFence !== undefined || planDetailsState.editingGeoFence !== undefined) {
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_EDITING_GEO_FENCE,
        payload: {
          editingGeoFence,
        },
      });
    }
  };

  return {
    run,
    data: planDetailsState.editingGeoFence,
  };
};
